import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import { ensureArray } from '@/lib/utils/ensure-array';
import type { FlashMessage, FlashMessageEditRequest } from './types';

export const flashMessageKeys = {
  all: ['flash-messages'] as const,
  list: () => ['flash-messages', 'list'] as const,
};

/** GET /api/obd/get/flash/messages */
export function useFlashMessages() {
  return useQuery({
    queryKey: flashMessageKeys.list(),
    queryFn: () => api.get<FlashMessage[]>('/api/obd/get/flash/messages'),
    staleTime: 60_000,
    select: (d) => ensureArray<FlashMessage>(d),
  });
}

/** POST /api/obd/edit/flash/message */
export function useEditFlashMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: FlashMessageEditRequest) =>
      api.post<{ message?: string } | undefined>(
        '/api/obd/edit/flash/message',
        body,
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: flashMessageKeys.all }),
  });
}
